import {createReducerFromMapping} from 'redux/utils/index.js';

const LOAD_ME = 'ServiFlex/UserProfile/LOAD_ME',
    LOAD_ME_SUCCESS = 'ServiFlex/UserProfile/LOAD_ME_SUCCESS',
    LOAD_ME_FAIL = 'ServiFlex/UserProfile/LOAD_ME_FAIL',
    LOAD_APPROVERS = 'ServiFlex/UserProfile/LOAD_APPROVERS',
    LOAD_APPROVERS_SUCCESS = 'ServiFlex/UserProfile/LOAD_APPROVERS_SUCCESS',
    LOAD_APPROVERS_FAIL = 'ServiFlex/UserProfile/LOAD_APPROVERS_FAIL',
    LOGOUT = 'ServiFlex/UserProfile/LOGOUT',
    LOGOUT_SUCCESS = 'ServiFlex/UserProfile/LOGOUT_SUCCESS',
    LOGOUT_FAIL = 'ServiFlex/UserProfile/LOGOUT_FAIL';

const initialState = {
    loaded: false,
    loading: [],
    user: {},
    loadingApprovers: false,
    loadedApprovers: false,
    approvers: [],
    approversError: null
};

export default createReducerFromMapping({
    [LOAD_ME]: (state, action) => ({
        ...state,
        loading: state.loading.concat([action.key])
    }),
    [LOAD_ME_SUCCESS]: (state, action) => ({
        ...state,
        loading: state.loading.filter(x => x !== action.key),
        user: action.result,
    }),
    [LOAD_ME_FAIL]: (state, action) => ({
        ...state,
        loading: state.loading.filter(x => x !== action.key),
        user: action.error,
        error: action.error,
    }),
    [LOGOUT]: (state, action) => ({
        ...state,
        loggingOut: true
    }),
    [LOGOUT_SUCCESS]: (state, action) => ({
        ...state,
        loggingOut: false,
        user: null
    }),
    [LOGOUT_FAIL]: (state, action) => ({
        ...state,
        loggingOut: false,
        logoutError: action.error
    }),
    [LOAD_APPROVERS]: (state, action) => ({
        ...state,
        loadingApprovers: true
    }),
    [LOAD_APPROVERS_SUCCESS]: (state, action) => ({
        ...state,
        loadingApprovers: false,
        loadedApprovers: true,
        approvers: action.result
    }),
    [LOAD_APPROVERS_FAIL]: (state, action) => ({
        ...state,
        loadingApprovers: false,
        loadedApprovers: true,
        approversError: action.error
    }),

}, initialState);

export function isLoaded(globalState) {
    return globalState.userProfile && globalState.userProfile.loaded;
}

export function load() {
    return {
        types: [LOAD_ME, LOAD_ME_SUCCESS, LOAD_ME_FAIL],
        promise: (client) => client.get(
            '/profiles/userinfo'
        )
    };
}

export function logout() {
    return {
        types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
        promise: (client) => client.get('/auth/logout')
    };
}

export function loadApprovers() {
    return {
        types: [LOAD_APPROVERS, LOAD_APPROVERS_SUCCESS, LOAD_APPROVERS_FAIL],
        promise: (client) => client.get(
            '/profiles/getApprovers'
        )
    };
}
